/**
 * API key for a plugin whose form has no `apiKey` field (username/password or address-only
 * plugins). Requests to the plugin server send it as `Authorization: Bearer <apiKey>`.
 */
export function generatePluginApiKey(pluginName: string): string {
  return `plugin-${pluginName}-${Date.now()}`;
}

/** Form secret field: opal-card uses `password`; Australian Super uses `pin` (stored as key password). */
export function credentialSecretFromForm(formValue: Record<string, string>): string | undefined {
  const secret = (formValue.password ?? formValue.pin ?? "").trim();
  return secret || undefined;
}

type SavedKeyFields = {
  username?: string | null;
  id?: string | null;
  password?: string | null;
  apiKey?: string | null;
};

/** Map vault key fields onto plugin form control names. */
export function mapSavedKeyToFormFields(
  savedKey: SavedKeyFields,
  formFieldNames: string[],
): Record<string, string> {
  const formValue: Record<string, string> = {};

  if (formFieldNames.includes("id")) {
    formValue.id = savedKey.username || savedKey.id || "";
  }
  if (formFieldNames.includes("username")) {
    formValue.username = savedKey.username || "";
  }
  if (savedKey.password) {
    if (formFieldNames.includes("password")) {
      formValue.password = savedKey.password;
    }
    if (formFieldNames.includes("pin")) {
      formValue.pin = savedKey.password;
    }
  }
  if (formFieldNames.includes("apiKey") && savedKey.apiKey) {
    formValue.apiKey = savedKey.apiKey;
  }

  return formValue;
}
